import { createTheme } from '@mui/material/styles';
import {
    red,
    amber,
    pink,
    blue,
    // green,
    blueGrey,
    // brown,
    // deepPurple,
    // indigo,
    // purple,
    // deepOrange,
    lime,
} from '@mui/material/colors';
import { darken, lighten } from '@mui/material/styles';


const lightTheme = createTheme({
    palette: {
        mode: 'light',
        text: {
            primary: '#000',
            secondary: '#777',
            disabled: '#aaa',
        },
        primary: {
            // main: '#52e052', // this is the same green from highways in the "light" map
            main: blueGrey[500],
            contrastText: '#fff',
        },
        secondary: {
            main: red[500],
            contrastText: '#f6f7f9',
        },
        success: {
            main: blueGrey[500],
            contrastText: '#fff',
        },
        info: {
            main: blue.A200,
            contrastText: blue[50],
        },
        warning: {
            main: amber.A200,
            contrastText: '#333',
        },
        error: {
            main: red.A400,
            contrastText: red[50],
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: "#f6f7f9",
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    // backgroundColor: '#52e052',
                    // backgroundColor: deepOrange[800],
                    backgroundColor: blueGrey[700],
                    color: '#fff',
                }
            }
        }
    },
    typography: {
        fontFamily: '"Ubuntu", "Lato", "San Francisco", Helvetica, Arial, sans-serif',
    }
})

const solarizedTheme = createTheme({
    palette: {
        mode: 'dark',
        text: {
            primary: '#fff',
            secondary: '#aaa',
        },
        primary: {
            main: lime.A200,
            contrastText: '#333',
        },
        secondary: {
            main: pink.A200,
            contrastText: '#f2f3f4',
        },
        success: {
            // main: green.A200,
            // contrastText: green[900],
            main: lighten('#1f2930', .3),
            contrastText: '#fff',
        },
        info: {
            main: blue.A200,
            contrastText: blue[50],
        },
        warning: {
            main: amber.A200,
            contrastText: '#333',
        },
        error: {
            main: red.A400,
            contrastText: red[50],
        }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: "#172b3a",
                    contrastText: '#555e66',
                },
            },
        },
        MuiAppBar: {
            defaultProps: {
                enableColorOnDark: true
            },
            styleOverrides: {
                root: {
                    color: '#fff',
                    backgroundColor: '#09141c',
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: darken('#0f202d', .3),
                }
            }
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    backgroundColor: '#09141c',
                    color: '#f2f3f4',
                }
            }
        },
    },
    typography: {
        fontFamily: '"Ubuntu", "Lato", "San Francisco", Helvetica, Arial, sans-serif',
    }
});

export const PrintableTheme = createTheme({})

export const themeMap = {
    "light": lightTheme,
    "dark": solarizedTheme,
}